import { Spinner } from "react-bootstrap";
import { useRecoilValue } from "recoil";
import { overlayState } from "atoms";

function Overlay() {
  const showOverlay = useRecoilValue(overlayState);
  return (
    <>
      {showOverlay ? (
        <div className='overlay'>
          <Spinner animation='border' />
        </div>
      ) : null}
    </>
  );
}

export default Overlay;
